import React, { useContext, useEffect, useState } from "react";
import "./style.css";
import MyInput from "../../../MyInput";
import { RemoveFilter } from "../../../../utils/func";
import { filterDataContext } from "../../../../App";

const PriceRange = ({
  createFilterParams,
  searchParams,
  setSearchParams,
}) => {
  const { minPriceInput, setMinPriceInput, maxPriceInput, setMaxPriceInput } =
    useContext(filterDataContext);

  useEffect(() => {
    if (searchParams.get("minPrice")) {
      setMinPriceInput(searchParams.get("minPrice"));
    }
    if (searchParams.get("maxPrice")) {
      setMaxPriceInput(searchParams.get("maxPrice"));
    }
  }, []);

  const filterPrice = () => {
    let price_range = {};
    if (minPriceInput.length > 0 && maxPriceInput.length > 0) {
      price_range = { price: minPriceInput + "/" + maxPriceInput };
    } else if (minPriceInput.length > 0) {
      price_range = { minPriceInput: minPriceInput };
    } else if (maxPriceInput.length > 0) {
      price_range = { maxPriceInput: maxPriceInput };
    }
    createFilterParams(price_range);
  };

  const RemoveParam = () => {
    searchParams.delete("minPrice");
    searchParams.delete("maxPrice");
    setSearchParams(searchParams);
  };

  useEffect(() => {
    if (minPriceInput.length > 0 || maxPriceInput.length > 0) {
      if (minPriceInput > 0 || maxPriceInput > 0) {
        filterPrice();
      }
    } else {
      RemoveParam();
    }
  }, [minPriceInput, maxPriceInput]);

  return (
    <div className="price_range">
      <MyInput
        inputType={"number"}
        placeholderText="Min Price"
        value={minPriceInput}
        func={setMinPriceInput}
        min={0}
      />
      <MyInput
        inputType={"number"}
        placeholderText="Max Price"
        value={maxPriceInput}
        func={setMaxPriceInput}
        min={0}
      />
    </div>
  );
};

export default PriceRange;
